import SummaryCardView from "./SummaryCardView";
import React, { useEffect, useState } from "react";
import { Alert, Button } from "reactstrap";
import SummaryCardTableView from "./SummaryCardTableView";
import AppNavbar from "components/AppNavbar/AppNavbar";
import useModule from "hooks/useModule";
import { useMemo } from "react";

export default function MultiSourceSummaryView({
  sources,
  records,
  fieldSchema,
  mode,
  collapse,
}) {
  const { getModule } = useModule();
  const [activeTab, setActiveTab] = useState(sources[0]);
  const [page, setPage] = useState(0);
  useEffect(() => {
    const page = {};
    sources.forEach((s) => (page[s] = 0));
    setPage(page);
  }, [sources]);

  const tabs = useMemo(() => {
    if (!sources) return null;

    return sources.map((moduleAPIName) => {
      const module = getModule(moduleAPIName);

      return {
        title: module?.Name,
        activeValue: moduleAPIName,
      };
    });
  }, [getModule, sources]);

  const mappedRecords = useMemo(() => {
    if (!records) return null;

    let mappedRecords = {};

    sources?.forEach((s) => {
      mappedRecords = { ...mappedRecords, [s]: [] };
    });

    records?.forEach((r) => {
      mappedRecords[r._ModuleAPIName].push(r);
    });

    return mappedRecords;
  }, [records, sources]);

  const nextPage = (source) => {
    setPage((prev) => {
      if (prev[source] < mappedRecords[source].length - 1) prev[source] += 1;
      return {
        ...prev,
      };
    });
  };

  const prevPage = (source) => {
    setPage((prev) => {
      if (prev[source] > 0) prev[source] -= 1;
      return {
        ...prev,
      };
    });
  };

  if (!records || records.length === 0) {
    return (
      <Alert color="superlight" className="font-weight-500 mt-2">
        No records selected. Click edit to choose records.
      </Alert>
    );
  }

  const CurrentTab = () => {
    const moduleAPIName = activeTab;
    if (!mode || !mappedRecords) return null;

    // update field schema sources list
    const updatedFieldSchema = {
      ...fieldSchema,
      SourcesList: `Tenant.Modules.${moduleAPIName}`,
    };

    switch (mode) {
      case "SummaryTable":
        return (
          <SummaryCardTableView
            records={mappedRecords[moduleAPIName]}
            fieldSchema={updatedFieldSchema}
            moduleAPIName={moduleAPIName}
          />
        );
      case "SummaryCard":
        return (
          <>
            <SummaryCardView
              record={mappedRecords[moduleAPIName][page[moduleAPIName]]}
              fieldSchema={updatedFieldSchema}
              fields={fieldSchema.RecordSummaryFields[moduleAPIName].Fields}
              readOnly={true}
              moduleAPIName={moduleAPIName}
              collapse={collapse}
            />
            {mappedRecords[moduleAPIName].length > 1 && (
              <div className="d-flex border-top justify-content-between align-items-center p-2">
                <Button
                  onClick={() => prevPage(moduleAPIName)}
                  outline
                  size="sm"
                  className="btn-icon-only"
                >
                  <i className="mdi mdi-chevron-left" />
                </Button>
                <small className="font-weight-500 text-dark">
                  {page[moduleAPIName] + 1} of{" "}
                  {mappedRecords[moduleAPIName].length}
                </small>
                <Button
                  onClick={() => nextPage(moduleAPIName)}
                  outline
                  size="sm"
                  className="btn-icon-only"
                >
                  <i className="mdi mdi-chevron-right" />
                </Button>
              </div>
            )}
          </>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <AppNavbar tabs={tabs} activeTab={activeTab} onSelect={setActiveTab} />
      <CurrentTab />
    </>
  );
}
